"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var polished_1 = require("polished");
var react_router_dom_1 = require("react-router-dom");
var link_1 = __importDefault(require("next/link"));
var config_1 = require("../util/config");
exports.Link = (0, styled_components_1.default)(function (_a) {
    var _b;
    var secondary = _a.secondary, color = _a.color, underline = _a.underline, to = _a.to, children = _a.children, rest = __rest(_a, ["secondary", "color", "underline", "to", "children"]);
    var ssrCompatible = (0, react_1.useContext)(config_1.ChocolatesContext).ssr;
    if (to && !ssrCompatible)
        return (react_1.default.createElement(react_router_dom_1.Link, __assign({ to: to }, rest), children));
    if (((_b = rest.href) === null || _b === void 0 ? void 0 : _b.includes('http')) || !ssrCompatible)
        return react_1.default.createElement("a", __assign({}, rest), children);
    return (react_1.default.createElement(link_1.default, { href: to || rest.href },
        react_1.default.createElement("a", __assign({}, rest), children)));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n\n  text-decoration: ", ";\n\n  &:hover,\n  &:active {\n    cursor: pointer;\n    color: ", ";\n    text-decoration: underline;\n  }\n\n  &:disabled {\n    cursor: initial;\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n\n  text-decoration: ", ";\n\n  &:hover,\n  &:active {\n    cursor: pointer;\n    color: ", ";\n    text-decoration: underline;\n  }\n\n  &:disabled {\n    cursor: initial;\n    color: ", ";\n  }\n"])), function (_a) {
    var secondary = _a.secondary, theme = _a.theme, color = _a.color;
    return secondary ? theme.colors.text : color ? color : theme.colors.primary;
}, function (_a) {
    var underline = _a.underline;
    return (underline ? 'underline' : 'none');
}, function (_a) {
    var secondary = _a.secondary, theme = _a.theme, color = _a.color;
    return secondary
        ? theme.colors.text
        : color
            ? (0, polished_1.darken)(0.1, color)
            : theme.colors.primaryDark;
}, function (_a) {
    var secondary = _a.secondary, theme = _a.theme, color = _a.color;
    return secondary
        ? theme.colors.textDisabled
        : color
            ? (0, polished_1.lighten)(0.2, color)
            : theme.colors.primaryLightest;
});
var templateObject_1;
//# sourceMappingURL=Link.js.map